import { FormFields } from 'app/modules/filingFormGenerator/models';
import {
  selectField,
  textField,
  textareaField,
} from 'app/modules/goAML/formConfig/fields/fieldBuilders';
import { GoamlReferenceTables } from 'app/modules/goAML/queries/useGetGoamlFiuConfig';

type FieldValues = Record<string, any>;

export const getPhoneFields = (
  referenceTables: GoamlReferenceTables,
): FormFields<FieldValues> => [
  selectField(
    {
      name: 'phone.tph_contact_type',
      label: 'Contact type',
      required: true,
      refTable: 'contact_type',
    },
    referenceTables,
  ),
  selectField(
    {
      name: 'phone.tph_communication_type',
      label: 'Communication type',
      required: true,
      defaultValue: 'L',
      refTable: 'communication_type',
    },
    referenceTables,
  ),
  textField({
    name: 'phone.tph_country_prefix',
    label: 'Country prefix',
    required: true,
    defaultValue: '+1',
  }),
  textField({ name: 'phone.tph_number', label: 'Number', required: true }),
  textField({ name: 'phone.tph_extension', label: 'Extension' }),
  textareaField({ name: 'phone.comments', label: 'Comments' }),
];
